import axios from "axios";

const { REACT_APP_NOTIFICATION_API } = process.env;

export const getEmailTemplates = () => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  return axios({
    method: "get",
    url: `${REACT_APP_NOTIFICATION_API}/email_mapping`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      return { data: response.data.data };
    })
    .catch((error) => {
      return { details: error.response.data.details };
    });
};

export const updateEmailTemplates = (data) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  return axios({
    method: "put",
    url: `${REACT_APP_NOTIFICATION_API}/email_mapping`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data,
  })
    .then((response) => {
      return { data: response.data.data };
    })
    .catch((error) => {
      return { details: error.response.data.details };
    });
};
